import { t } from "@lingui/macro";
import * as React from "react";
import { Circle, Path, G, Defs, ClipPath, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const SunsetIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Sunset`} {...props}>
    <G clipPath="url(#clip0_3173_36539)">
      <Circle
        cx="8"
        cy="16"
        r="3.25"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M8 2V10M8 10L10.9999 7.00009M8 10L5.00009 7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M0.799805 15L2.3998 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M13.5996 15L15.1996 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M11.9609 12.0405L13.0923 10.9092"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M4.04102 12.0405L2.90964 10.9092"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_3173_36539">
        <Rect width="16" height="16" fill="white" />
      </ClipPath>
    </Defs>
  </Icon>
);
